import { render, staticRenderFns } from "./ChannelAccessDialog.vue?vue&type=template&id=5f6b4d45&scoped=true"
import script from "./ChannelAccessDialog.vue?vue&type=script&lang=js"
export * from "./ChannelAccessDialog.vue?vue&type=script&lang=js"
import style0 from "./ChannelAccessDialog.vue?vue&type=style&index=0&id=5f6b4d45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6b4d45",
  null
  
)

export default component.exports